import React from "react";
import './menucardforallpage.css';

function Menucardforallpage(props) {
    let content;

    if (props.page === 'sse') {
        content = (
            <ul className="cs-card-group">
                <li className="cs-item">
                    <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/checkmark-circle-gold.svg" alt="icon" width="48" height="48" aria-hidden="true"></img>
                    <h3 className="cs-h3">Prayers and Bhajan</h3>
                    <p className="cs-item-text">
                        Cultivate divine Love, achieve inner Peace, express Gratitude, and strengthen connection with God, fostering personal and spiritual growth.
                    </p>
                    <a href="https://sairhythms.sathyasai.org/" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <img className="cs-icon" loading="lazy" decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/Lifebuoy-gold.svg" alt="icon" width="48"
                            height="48" aria-hidden="true"></img>
                    <h3 className="cs-h3">Service</h3>
                    <p className="cs-item-text">
                        Service to others is a way to express love and compassion, promote selflessness, and contribute to the well-being of individuals and communities, reflecting the teachings of Sri Sathya Sai Baba.
                    </p>
                    <a href="/service" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <img className="cs-icon" loading="lazy" decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/Like-gold.svg" alt="icon" width="48"
                            height="48" aria-hidden="true"></img>
                    <h3 className="cs-h3">Gallery</h3>
                    <p className="cs-item-text">
                        Experiencing the joy of community, celebrating shared values, and fostering a sense of belonging among members through collective activities and events.
                    </p>
                    <a href="/gallery" className="cs-button-solid">Read More</a>
                </li>
            </ul>
        );
    } else if (props.page === 'service') {
        content = (
            <ul className="cs-card-group">
                <li className="cs-item">
                    <img className="cs-icon" loading="lazy" decoding="async" src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/checkmark-circle-gold.svg" alt="icon" width="48" height="48" aria-hidden="true"></img>
                    <h3 className="cs-h3">Prayers and Bhajan</h3>
                    <p className="cs-item-text">
                        Cultivate divine Love, achieve inner Peace, express Gratitude, and strengthen connection with God, fostering personal and spiritual growth.
                    </p>
                    <a href="https://sairhythms.sathyasai.org/" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <img className="cs-icon" loading="lazy" decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/dashboard-gold.svg" alt="icon" width="48"
                            height="48" aria-hidden="true"></img>
                    <h3 className="cs-h3">SSE</h3>
                    <p className="cs-item-text">
                        Education in Human Values (EHV) nurtures character development, ethical awareness, and holistic growth in individuals, fostering a compassionate and responsible society.
                    </p>
                    <a href="/sse" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <img className="cs-icon" loading="lazy" decoding="async"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/Like-gold.svg" alt="icon" width="48"
                            height="48" aria-hidden="true"></img>
                    <h3 className="cs-h3">Gallery</h3>
                    <p className="cs-item-text">
                        Experiencing the joy of community, celebrating shared values, and fostering a sense of belonging among members through collective activities and events.
                    </p>
                    <a href="/gallery" className="cs-button-solid">Read More</a>
                </li>
            </ul>
        );
    } else if (props.page === 'contact') {
        content = (
            <ul className="cs-card-group">
                <li className="cs-item">
                    <h3 className="cs-h3">Service</h3>
                    <p className="cs-item-text">
                        Service to others is a way to express love and compassion, promote selflessness, and contribute to the well-being of individuals and communities, reflecting the teachings of Sri Sathya Sai Baba.
                    </p>
                    <a href="/service" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <h3 className="cs-h3">SSE</h3>
                    <p className="cs-item-text">
                        Education in Human Values (EHV) nurtures character development, ethical awareness, and holistic growth in individuals, fostering a compassionate and responsible society.
                    </p>
                    <a href="/sse" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <h3 className="cs-h3">Gallery</h3>
                    <p className="cs-item-text">
                        Experiencing the joy of community, celebrating shared values, and fostering a sense of belonging among members through collective activities and events.
                    </p>
                    <a href="/gallery" className="cs-button-solid">Read More</a>
                </li>
            </ul>
        );
    } else if (props.page === 'sathyasai100birthday') {
        content = (
            <ul className="cs-card-group">
                <li className="cs-item">
                    <h3 className="cs-h3">Service</h3>
                    <p className="cs-item-text">
                        Service to others is a way to express love and compassion, promote selflessness, and contribute to the well-being of individuals and communities, reflecting the teachings of Sri Sathya Sai Baba.
                    </p>
                    <a href="/service" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <h3 className="cs-h3">SSE</h3>
                    <p className="cs-item-text">
                        Education in Human Values (EHV) nurtures character development, ethical awareness, and holistic growth in individuals, fostering a compassionate and responsible society.
                    </p>
                    <a href="/sse" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <h3 className="cs-h3">Gallery</h3>
                    <p className="cs-item-text">
                        Experiencing the joy of community, celebrating shared values, and fostering a sense of belonging among members through collective activities and events.
                    </p>
                    <a href="/gallery" className="cs-button-solid">Read More</a>
                </li>
            </ul>
        );
    } else {
        content = (
            <ul className="cs-card-group">
                <li className="cs-item">
                    <h3 className="cs-h3">Service</h3>
                    <p className="cs-item-text">
                        Service to others is a way to express love and compassion, promote selflessness, and contribute to the well-being of individuals and communities, reflecting the teachings of Sri Sathya Sai Baba.
                    </p>
                    <a href="/service" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <h3 className="cs-h3">SSE</h3>
                    <p className="cs-item-text">
                        Education in Human Values (EHV) nurtures character development, ethical awareness, and holistic growth in individuals, fostering a compassionate and responsible society.
                    </p>
                    <a href="/sse" className="cs-button-solid">Read More</a>
                </li>
                <li className="cs-item">
                    <h3 className="cs-h3">Gallery</h3>
                    <p className="cs-item-text">
                        Experiencing the joy of community, celebrating shared values, and fostering a sense of belonging among members through collective activities and events.
                    </p>
                    <a href="/gallery" className="cs-button-solid">Read More</a>
                </li>
            </ul>
        );
    }

    return (
        <section id="services-2371">
            <div className="cs-container">
                {content}
            </div>
        </section>
    );
}

export default Menucardforallpage;